import { portalItems } from '../constants/portal';
import { mainRoutes } from '../constants/routes';
import { Portal, PortalLink } from '../enums/portal.enum';
import { MenuItem, PinnedAppMenuItem } from '../types/menu-item';

export default function getPinnedApps(
  premiumRoutes: string[],
): PinnedAppMenuItem[] {
  if (typeof window === 'undefined') return [];

  const pinnedApps = localStorage.getItem('pinnedApps');
  const pinnedAppRoutes = pinnedApps ? pinnedApps.split(',') : [];
  if (!pinnedAppRoutes.length) return [];

  return pinnedAppRoutes
    .map((route) => {
      // Extract portal code from route
      const [, portalCode] = route.split('/');
      const portalEntry = Object.entries(PortalLink).find(
        ([, path]) => path === `/${portalCode}`,
      );

      const portalId = portalEntry
        ? (portalEntry[0] as Portal)
        : Portal.PHILIPPINES;
      const portal = portalItems.find((p) => p.id === portalId);

      const featurePath = route.substring(route.indexOf('/', 1));
      const routeConfig = mainRoutes.find(
        (route) => route.link === featurePath,
      );

      if (!routeConfig) return null;
      const menuItem = {
        type: MenuItem.PINNED_APP,
        name: routeConfig.label,
        href: route,
        isNew: routeConfig.isNewFeature || false,
        isPremium: premiumRoutes.includes(routeConfig.link),
        logo: portal?.logo,
      };

      return menuItem;
    })
    .filter(Boolean) as PinnedAppMenuItem[];
}
